import { render } from "./HeaderButton.vue?vue&type=template&id=e483a008"
import script from "./HeaderButton.vue?vue&type=script&lang=js"
export * from "./HeaderButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Button/HeaderButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e483a008"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e483a008', __exports__)) {
    api.reload('e483a008', __exports__)
  }
  
  module.hot.accept("./HeaderButton.vue?vue&type=template&id=e483a008", () => {
    api.rerender('e483a008', render)
  })

}


export default __exports__